<template>
  <div class="carbonSinkResources">
    <el-col :span="24">
      <Breadcrumbs :arr="['碳汇管理平台', '碳汇资源管理平台']" />
      <!-- 全屏按钮 -->
      <div class="full" @click="handleFullScreen">
        <img :src="require('@/assets/img/o.png')" alt="" />
      </div>
    </el-col>
    <el-col
      :span="24"
      class="echart_content"
      id="Echart_cont"
      style="background: #0c152b"
    >
      <div id="fullscreen">
        <div class="dialog" v-if="dialogVisible">
          <div id="Map1" ></div>
          <div class="map_cont" style="top: 33.5rem;left: 62.6667rem;transform: scale(1.5)">
            <div class="map_cont_title" >
              全县森林碳储量约<span>1468.23</span>万吨
            </div>
            <div class="map_cont_c">
              <span>平均碳密度约3.6吨/亩</span>
            </div>
          </div>
          <table class="map_table" style="top: 3.2rem;left: 61.2rem;transform: scale(1.5)">
            <tr><th>乡镇名</th><th>乔木林蓄积<div>(万立方米)</div></th><th>生物量<div>(万吨)</div></th><th>碳储量<div>(万吨)</div></th><th>碳密度<div>(吨/公顷)</div></th></tr>
            <tr v-for="(item,index) in mapData" :key="index">
              <td>{{item.name}}</td>
              <td>{{item.data1}}</td>
              <td>{{item.data2}}</td>
              <td>{{item.data3}}</td>
              <td>{{item.data4}}</td>
            </tr>
          </table>
        </div>
        <div class="content">
          <!-- 左侧内容 -->
          <div class="content_left">
            <!-- 碳排贡献率 -->
            <div class="content_left_item1">
              <div class="cont_title"><div>{{year}}年碳排贡献率</div></div>
              <div class="Echarts_left_1">
                <Echarts ref="echarts1" />
              </div>
            </div>
            <!-- 各行业碳排放排行 -->
            <div class="content_left_item2">
              <div class="cont_title"><div>{{year}}年各行业碳排放排行</div></div>
              <div class="Echarts_left_2">
                <ProgressBar ref="progressBar" :dataList="iceMap" />
                <!-- <Echarts ref="echarts2" /> -->
              </div>
            </div>
            <!-- 历年碳排趋势分析 -->
            <div class="content_left_item3">
              <div class="cont_title"><div>历年碳排趋势分析</div></div>
              <div class="Echarts_left_3">
                <Echarts ref="echarts3" />
              </div>
            </div>
          </div>
          <!-- 中间内容 -->
          <div class="content_center">
            <div class="content_center_tit">红河林碳管理平台</div>
            <!-- 碳排放总量 -->
            <div class="content_center_total">
              <div class="total_tit">{{year}}年碳排放总量</div>
              <div class="total_cont">
                <div
                  class="total_cont_item"
                  v-for="(item, index) in aceMap.arr"
                  :key="index"
                >
                  {{ item }}
                </div>
                <div class="total_unit">吨</div>
              </div>
            </div>
            <!-- 碳吸收总量（包括天然林） -->
            <div class="conten_item_l">
              <div class="conten_item_t">{{year}}年碳吸收总量（包括天然林）</div>
              <div class="conten_item_c">
                {{ aceMap.plantedForest }}<span> 吨</span>
              </div>
            </div>
            <!-- 可供抵消的碳吸收总量 -->
            <!-- <div class="conten_item_r">
              <div class="conten_item_t">{{year}}年可供抵消的碳吸收总量</div>
              <div class="conten_item_c">
                {{ aceMap.hydropower }}<span> 吨</span>
              </div>
            </div> -->
            <!-- 中间地图 -->
            <div id="Map" v-show="mapShow"></div>
            <!--            表格-->
            <table class="map_table" v-show="mapShow">
              <tr><td>乡镇名</td><td>乔木林蓄积<div>(万立方米)</div></td><td>生物量<div>(万吨)</div></td><td>碳储量<div>(万吨)</div></td><td>碳密度<div>(吨/公顷)</div></td></tr>
              <tr v-for="(item,index) in mapData" :key="index">
                <td>{{item.name}}</td>
                <td>{{item.data1}}</td>
                <td>{{item.data2}}</td>
                <td>{{item.data3}}</td>
                <td>{{item.data4}}</td>
              </tr>
            </table>
            <!-- 地图详情信息 -->
            <div class="map_cont" v-show="mapShow">
              <div class="map_cont_title">
                全县森林碳储量约<span>1468.23</span>万吨
              </div>
              <div class="map_cont_c">
                <span>平均碳密度约3.6吨/亩</span>
              </div>
            </div>
            <!-- 工作推进成果 -->
            <div class="content_b">
              <div class="cont_title"><div>工作动态及成果</div></div>
              <!-- <Swiper>
              </Swiper> -->
              <el-carousel
                trigger="click"
                height="9rem"
                :interval="3000"
                indicator-position="none"
                style="margin: 0.4167rem 0 0 0"
              >
                <el-carousel-item
                  v-for="(item, index) in mediaCoverage"
                  :key="index"
                  class="content_b_video"
                >
                  <div style="cursor: pointer;" v-for="items in item" :key="items.id" @click="toPathDetail(items.detailId)">
                    <video
                      v-if="items.type == 'mp4' || items.type == 'mov'"
                      :src="items.url"
                      controls="controls"
                      :autoplay="false"
                    ></video>
                    <img
                      v-else-if="
                        items.type == 'jpg' ||
                        items.type == 'png' ||
                        items.type == 'jpeg' ||
                        items.type == 'svg' ||
                        items.type == 'webp' ||
                        items.type == 'jfif'
                      "
                      :src="items.url"
                      alt=""
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="content_right">
            <div class="content_right_item1">
              <div class="cont_title"><div>{{year}}年碳吸收贡献量</div></div>
              <div class="Echarts_right_1">
                <Echarts ref="echarts5" />
              </div>
            </div>
            <div class="content_right_item2">
              <div class="cont_title"><div>{{year}}年碳吸收贡献率</div></div>
              <div class="content_item2_cont">
                <span>汇总</span>
                <div>{{ cerMap.sum }}</div>
                <span style="margin: 0 0 0 0.25rem">吨</span>
              </div>
              <div class="Echarts_right_2_4">
                <Echarts ref="echarts6" />
                <div class="Echarts_cont">
                  <em>{{ cerMap.biogasManure }}%</em>
                  <span>沼气粪肥</span>
                </div>
              </div>
              <div class="Echarts_right_2_1">
                <Echarts ref="echarts7" />
                <div class="Echarts_cont">
                  <em>{{ cerMap.plantedForest }}%</em>
                  <span>人工林</span>
                </div>
              </div>
              <div class="Echarts_right_2_3">
                <Echarts ref="echarts8" />
                <div class="Echarts_cont">
                  <em>{{ cerMap.hydropower }}%</em>
                  <span>水电</span>
                </div>
              </div>
              <div class="Echarts_right_2_2">
                <Echarts ref="echarts9" />
                <div class="Echarts_cont">
                  <em>{{cerMap.teaCoffee}}%</em>
                  <span>天然林</span>
                </div>
              </div>
            </div>
            <div class="content_right_item3">
              <div class="cont_title"><div>政策信息发布</div></div>
              <ScrollList :Data="policyLearning"></ScrollList>
            </div>
             <div class="content_right_item4">
              <div class="cont_title"><div>研究成果</div></div>
              <ScrollList :Data="researchResult" type="1"></ScrollList>
            </div>
          </div>
        </div>
      </div>
    </el-col>


  </div>
</template>
<script>
import Echarts from "@/components/echarts/echarts.vue";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import ScrollList from "@/components/scrollList/scrollList.vue";
import ProgressBar from "@/components/progressBar/progressBar.vue";
import Swiper from "@/components/swiper/swiper.vue";
import { Dialog } from 'element-ui';
import { getBigScreenData } from "@/api/api";
import { ninger } from "@/assets/js/mapInfo.js";
let _this;
export default {
  name: "carbonSinkResources",
  data() {
    return {
      mapData:[],
      list: [
        // {
        //   name: "茶叶咖啡种植",
        //   value: "0",
        // },
        {
          name: "沼气粪肥",
          value: "0",
        },
        {
          name: "人工林",
          value: "0",
        },
        {
          name: "天然林",
          value: "0",
        },
        {
          name: "水电",
          value: "0",
        },
        {
          name: "o",
          value: "0",
        },
        {
          name: "o",
          value: "0",
        },
        {
          name: "o",
          value: "0",
        },
        {
          name: "o",
          value: "0",
        },
        // {
        //   name: "o",
        //   value: "0",
        // },
      ],
      width: 1920,
      height: 1080,
      option1: {
        // color: ["#8C57DC", "#D6D02B", "#18AEF0", "#02DBE3"],
        color: ["#02DBE3", "#18AEF0", "#D6D02B", "#8C57DC"],
        grid: {
          top: "0",
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          show: false,
        },
        series: [
          {
            name: "年龄分布",
            type: "pie",
            radius: ["40%", "60%"],
            center: ["40%", "50%"],
            avoidLabelOverlap: false,
            labelLine: {
              // offset:,
              normal: {
                show: false,
                length: ((screen.availWidth - 374) * 10) / 1546, // 指示线长度
                lineStyle: {
                  // color: ["#0AEADA", "#FFC907", "#E25C18",'#8F1AEE','#03A2E8'] // 指示线颜色
                },
              },
            },
            // itemStyle:{
            //    color:(params)=> {
            //       var index = params.dataIndex;
            //       return _this.option1.color[index];
            //     },
            // },
            roseType: "area",
            label: {
              color: "#fff",
              position: "outside",
              fontSize: ((screen.availWidth - 374) * 16) / 1546,
              height: ((screen.availWidth - 374) * 40) / 1546,
              itemStyle: {
                // normal: {
                //   shadowColor: "rgba(255,227,42,0.3)",
                //   shadowBlur: ((screen.availWidth - 374) * 20) / 1546,
                // },
              },
              formatter: function (row) {
                // const arr = ["#0AEADA", "#FFC907", "#E25C18",'#8F1AEE','#03A2E8'];
                const { name, proportion } = row.data;
                let bgc = "";
                if (name == "工业排放量") bgc = "aa";
                else if (name == "农业排放量") bgc = "bb";
                else if (name == "其他行业量") bgc = "cc";
                else if (name == "交通运输排放量") bgc = "dd";
                // return '{aa|'+proportion+'%}' + '\n' + '{bb|'+name+'}'
                return (
                  "{name|" +
                  name +
                  "}" +
                  "\n" +
                  "{" +
                  bgc +
                  "| " +
                  proportion +
                  "% " +
                  "}"
                );
              },
              rich: {
                name: {
                  height: ((screen.availWidth - 374) * 20) / 1546,
                },
                aa: {
                  color: "#fff",
                  fontSize: ((screen.availWidth - 374) * 18) / 1546,
                  fontWeight: 400,
                  backgroundColor: "#02DBE3",
                },
                bb: {
                  color: "#fff",
                  fontSize: ((screen.availWidth - 374) * 18) / 1546,
                  fontWeight: 400,
                  backgroundColor: "#18AEF0",
                },
                cc: {
                  color: "#fff",
                  fontSize: ((screen.availWidth - 374) * 18) / 1546,
                  fontWeight: 400,
                  backgroundColor: "#D6D02B",
                },
                dd: {
                  color: "#fff",
                  fontSize: ((screen.availWidth - 374) * 18) / 1546,
                  fontWeight: 400,
                  backgroundColor: "#8C57DC",
                },
              },
            },
            data: [
              { value: 4000, name: "工业排放量", proportion: "24.77" },
              { value: 2589, name: "农业排放量", proportion: "16.03" },
              { value: 6000, name: "其他行业量", proportion: "37.15" },
              { value: 2562, name: "交通运输排放量", proportion: "15.86" },
            ],
          },
        ],
      },
      option3: {
        color: ["#03A2E8", "#0AEADA", "#8B19E7", "#FFC907"],
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            // width:20,
            // type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
          backgroundColor: "rgba(8,43,54,.8)",
          borderColor: "#082B36",
          extraCssText:
            "box-shadow:inset 0px 0px 3px 0px rgba(255,255,255,1);width:8.0833rem;height:5.25rem;",
          textStyle: {
            color: "#fff",
          },
          itemWidth: ((screen.availWidth - 374) * 6) / 1546,
          itemHeight: ((screen.availWidth - 374) * 6) / 1546,
          formatter: function (params) {
            var result = ""; //
            var cont = ""; // 内容
            var tit = ""; // 标题文本
            var sum = 0; // 总人数
            function addStyle(val) {
              if (val == "工业生产") return "color:#03A2E8;";
              else if (val == "农业生产") return "color:#0AEADA;";
              else if (val == "交通运输") return "color:#8B19E7;";
              else if (val == "其他行业") return "color:#FFC907;";
            }
            params.forEach(function (item) {
              sum += item.data;
              tit = item.axisValueLabel;
              cont += `<div style="display:flex;align-items:center;justify-content: space-between;">
                  <span style="font-size: .5rem;">${item.marker}${
                item.seriesName
              }</span>
                  <span  style="${addStyle(
                    item.seriesName
                  )}font-size: .5833rem;">${item.value}</span>
                </div>`;
            });
            result =
              '<div style="width:8.0833rem;height: 5.25rem;display: flex;flex-direction: column;justify-content: space-between;"><div style="margin:0 0 .25rem ;display:flex;align-items:center;justify-content: space-between;font-size: .5833rem;"><span>' +
              tit +
              '</span><span style="font-size: 0.4167rem;">单位：吨</span></div>' +
              cont +
              "</div>";
            return result;
          },
        },
        legend: {
          top: ((screen.availWidth - 374) * 6) / 1546,
          show: true,
          itemWidth: ((screen.availWidth - 374) * 6) / 1546,
          itemHeight: ((screen.availWidth - 374) * 6) / 1546,
          itemStyle: {
            // color: "rgba(154, 31, 31, 1)"
          },
          textStyle: {
            // fontSize: ((screen.availWidth - 374) * 14) / 1546, //字体大小
            fontSize: ((screen.availWidth - 374) * 12) / 1546, //字体大小
            color: "#ffffff", //字体颜色
          },
          data: [
            {
              name: "工业生产",
              icon: "circle",
            },
            {
              name: "农业生产",
              icon: "circle",
            },
            {
              name: "交通运输",
              icon: "circle",
            },
            {
              name: "其他行业",
              icon: "circle",
            },
          ],
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            color: "#fff",
            data: ["2017", "2018", "2019", "2020", "2021"],
            axisLine: {
              lineStyle: {
                color: "rgba(151,151,151,.4)",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false, // 隐藏刻度线
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisTick: {
              show: false, // 隐藏刻度线
              alignWithLabel: true,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(151,151,151,.4)",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            name: "工业生产",
            type: "line",
            data: [0, 0, 101, 134, 90, 230, 210],
            smooth: true,
            symbol: "circle",
            showSymbol: false,
          },
          {
            name: "农业生产",
            type: "line",
            data: [220, 182, 191, 234, 290, 330, 310],
            smooth: true,
            symbol: "circle",
            showSymbol: false,
          },
          {
            name: "交通运输",
            type: "line",
            data: [150, 232, 201, 154, 190, 330, 410],
            smooth: true,
            symbol: "circle",
            showSymbol: false,
          },
          {
            name: "其他行业",
            type: "line",
            data: [320, 332, 301, 334, 390, 330, 320],
            smooth: true,
            symbol: "circle",
            showSymbol: false,
          },
        ],
      },
      fullscreen: false,
      date: "",
      time: "",
      timer: null,
      myChart: null,
      dialogVisible:false,
      mapShow:true,
      option4: {
        title:{
          text: '碳密度 吨/公顷',
              textStyle: {
            color: '#fff',
                fontSize: 12,
                fontWeight:'normal'
          },
          left: '10',
              bottom: 240,
              show: true,
        },
        toolbox: {
          //
          show: true,
          itemSize:20,
          feature: {
            myFull: {
              show: true,
              iconStyle:{
                color:'#fff'
              },
              onclick: () => {
                _this.showDialog()
                _this.mapShow=false

              },
            },
          },
        },

        tooltip: {
          top: 30,
          triggerOn: "click",
          backgroundColor: 'rgba(10,35,60,0.52)',
          textStyle: {
            color: '#fff',
          },
          enterable: true,
          formatter: (params)=>{
            let x=_this.mapData.find(x=>x.name==params.name)
            if(x){
              let str=`<table style="text-align: left">`+
                  `<tr><th colspan="2">${params.name}</th></tr>`+
                  `<tr><td style="padding-right:10px">乔木林蓄积</td><td style="text-align: right">${x.data1}万立方米</td></tr>`+
                  `<tr><td>生物量</td><td style="text-align: right">${x.data2}万吨</td></tr>`+
                  `<tr><td>碳储量</td><td style="text-align: right">${x.data3}万吨</td></tr>`+
                  `<tr><td>碳密度</td><td style="text-align: right">${x.data4}吨/公顷</td></tr>`

              return str
            }


          }
        },
        visualMap: {
          left:10,
          bottom:20,
          seriesIndex:0,
          tyoe:'piecewise',
          pieces: [
            {min: 62,color:'rgba(14,202,15,0.9)'}, // 不指定 max，表示 max 为无限大（Infinity）。
            {min: 60, max: 62,color:'rgba(53,210,45,0.9)'},
            {min: 58, max: 60,color:'rgba(76,215,67,0.9)'},
            {min: 56, max: 58,color:'rgba(100,222,90,0.9)'},
            {min: 54, max: 56,color:'rgba(122,230,111,0.9)'},
            {min: 52, max: 54,color:'rgba(142,235,133,0.9)'},
            {min: 50, max: 52,color:'rgba(163,243,157,0.9)'},
            {min: 48, max: 50,color:'rgba(182,248,180,0.9)'},
            {max: 48,color:'rgba(202,253,203,0.9)'}     // 不指定 min，表示 min 为无限大（-Infinity）。
          ],
          textStyle:{
            color:'#fff'
          }
        },
        geo: {
          map: "ninger",
          roam: true, //不开启缩放和平移
          zoom: 2, //视角缩放比例
          regions: [
            {
              name: "宁洱哈尼族彝族自治县",
              itemStyle: {
                normal: {
                  opacity: 1, // 透明度
                  areaColor: "rgba(12,181,189, 0.2)", // 整个省份的颜色
                  // borderColor:"rgba(26, 55, 99, 0.7)", // 省份界线颜色
                  // borderWidth: 3, // 省份界线的宽度
                },
              },
            },
          ],
          label: {
            normal: {
              show: true,
              fontSize: "10",
              color: "rgb(0,0,0)",
              lineHeight: 14,
              width: 100,
              overflow: "break",
              // formatter: (value) => {
              //   var str = ''
              //   for (let i = 0; i < value.name.length; i++) {
              //     if (i % 4 == 0 && i != 0) {
              //       str = str + value.name[i] + '\n'
              //     } else {
              //       str = str + value.name[i]
              //     }
              //   }
              //   return str
              // },
            },
          },
          // layoutCenter: ['45%', '70%'],
          // // 如果宽高比大于 1 则宽度为 100，如果小于 1 则高度为 100，保证了不超过 100x100 的区域
          // layoutSize: 100,
          center: [101.04524, 23.062507],
          itemStyle: {
            normal: {
              borderColor: "rgba(1,236,220,0.64)",
              borderWidth: 1,
              areaColor: "rgba(1,236,220, 0.3)", //地图颜色
            },
            emphasis: {
              areaColor: "rgba(12,181,189, 0.7)", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          emphasis:{
            label:{
              // color:"none"
              color:"#fff"
            },
          },
          select:{
            label:{
              color:'#FFF'
            },
            itemStyle:{
              areaColor: "rgba(1,236,220, 0.3)", //地图颜色
            }
          }
        },
        series: [
          // {
          //   type: "effectScatter",
          //   coordinateSystem: "geo",
          //   geoIndex: 0,
          // },
          {
            type: 'map',
            map: 'ninger',
            geoIndex: 0,
            data: [],
            symbolSize: 14,
            color: "#01ECDC ",
            label: {
              normal: {
                formatter: function (val) {
                  return val.data[3];
                },
                position: "right",
                color: "#fff",
                // show: true, //根据需求可以更改标点标签是否显示
              },
              emphasis: {
                show: true,
              },
            },
          },
          // {
          //   type: "scatter",
          //   coordinateSystem: "geo",
          //   geoIndex: 0,
          //   data: [[ 101.0920715332, 22.9915826206,9,'锅底塘村111'],],
          //   symbolSize: 24,
          //   color: "#01ECDC ",
          //   label: {
          //     normal: {
          //       formatter: function(val){
          //         return val.data[3]
          //       },
          //       position: "right",
          //       show: true, //根据需求可以更改标点标签是否显示
          //     },
          //     emphasis: {
          //       show: true,
          //     },
          //   },
          // },
        ],
      },
      option10: {
        title:{
          text: '碳密度 吨/公顷',
          textStyle: {
            color: '#fff',
            fontSize: 12,
            fontWeight:'normal'
          },
          left: '40',
          bottom: 280,
          show: true,
        },
        toolbox: {
          itemSize:24,
          //
          show: true,
          feature: {
            myFull: {
              show: true,
              onclick: () => {
                _this.closeDialog()

              },
            },
          },
        },
        tooltip: {
          top: 30,
          triggerOn: "click",
          backgroundColor: 'rgba(10,35,60,0.52)',
          textStyle: {
            color: '#fff',
          },
          enterable: true,
          formatter: (params)=>{
            let x=_this.mapData.find(x=>x.name==params.name)
            if(x){
              let str=`<table style="text-align: left">`+
                  `<tr><th colspan="2">${params.name}</th></tr>`+
                  `<tr><td style="padding-right:10px">乔木林蓄积</td><td style="text-align: right">${x.data1}万立方米</td></tr>`+
                  `<tr><td>生物量</td><td style="text-align: right">${x.data2}万吨</td></tr>`+
                  `<tr><td>碳储量</td><td style="text-align: right">${x.data3}万吨</td></tr>`+
                  `<tr><td>碳密度</td><td style="text-align: right">${x.data4}吨/公顷</td></tr>`

              return str
            }


          }
        },
        visualMap: {
          left:40,
          bottom:60,
          seriesIndex:0,
          tyoe:'piecewise',
          pieces: [
            {min: 62,color:'rgba(14,202,15,0.9)'}, // 不指定 max，表示 max 为无限大（Infinity）。
            {min: 60, max: 62,color:'rgba(53,210,45,0.9)'},
            {min: 58, max: 60,color:'rgba(76,215,67,0.9)'},
            {min: 56, max: 58,color:'rgba(100,222,90,0.9)'},
            {min: 54, max: 56,color:'rgba(122,230,111,0.9)'},
            {min: 52, max: 54,color:'rgba(142,235,133,0.9)'},
            {min: 50, max: 52,color:'rgba(163,243,157,0.9)'},
            {min: 48, max: 50,color:'rgba(182,248,180,0.9)'},
            {max: 48,color:'rgba(202,253,203,0.9)'}     // 不指定 min，表示 min 为无限大（-Infinity）。
          ],
          textStyle:{
            color:'#fff'
          }
        },
        geo: {
          map: "ninger",
          roam: true, //不开启缩放和平移
          zoom: 1, //视角缩放比例
          regions: [
            {
              name: "宁洱哈尼族彝族自治县",
              itemStyle: {
                normal: {
                  opacity: 1, // 透明度
                  areaColor: "rgba(12,181,189, 0.2)", // 整个省份的颜色
                  // borderColor:"rgba(26, 55, 99, 0.7)", // 省份界线颜色
                  // borderWidth: 3, // 省份界线的宽度
                },
              },
            },
          ],
          label: {
            normal: {
              show: true,
              fontSize: "12",
              color: "rgb(0,0,0)",
              lineHeight: 14,
              width: 100,
              overflow: "break",
              // formatter: (value) => {
              //   var str = ''
              //   for (let i = 0; i < value.name.length; i++) {
              //     if (i % 4 == 0 && i != 0) {
              //       str = str + value.name[i] + '\n'
              //     } else {
              //       str = str + value.name[i]
              //     }
              //   }
              //   return str
              // },
            },
          },
          // layoutCenter: ['45%', '70%'],
          // // 如果宽高比大于 1 则宽度为 100，如果小于 1 则高度为 100，保证了不超过 100x100 的区域
          // layoutSize: 100,
          center: [101.04524, 23.062507],
          itemStyle: {
            normal: {
              borderColor: "rgba(1,236,220,0.64)",
              borderWidth: 1,
              areaColor: "rgba(1,236,220, 0.3)", //地图颜色
            },
            emphasis: {
              areaColor: "rgba(12,181,189, 0.7)", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          emphasis:{
            label:{
              // color:"none"
              color:"#fff"
            },
          },
          select:{
            label:{
              color:'#FFF'
            },
            itemStyle:{
              areaColor: "rgba(1,236,220, 0.3)", //地图颜色
            }
          }
        },
        series: [
          // {
          //   type: "effectScatter",
          //   coordinateSystem: "geo",
          //   geoIndex: 0,
          // },
          {
            type: 'map',
            map: 'ninger',
            geoIndex: 0,
            data: [],
            symbolSize: 14,
            color: "#01ECDC ",
            label: {
              normal: {
                formatter: function (val) {
                  return val.data[3];
                },
                position: "right",
                color: "#fff",
                // show: true, //根据需求可以更改标点标签是否显示
              },
              emphasis: {
                show: true,
              },
            },
          },
          // {
          //   type: "scatter",
          //   coordinateSystem: "geo",
          //   geoIndex: 0,
          //   data: [[ 101.0920715332, 22.9915826206,9,'锅底塘村111'],],
          //   symbolSize: 24,
          //   color: "#01ECDC ",
          //   label: {
          //     normal: {
          //       formatter: function(val){
          //         return val.data[3]
          //       },
          //       position: "right",
          //       show: true, //根据需求可以更改标点标签是否显示
          //     },
          //     emphasis: {
          //       show: true,
          //     },
          //   },
          // },
        ],
      },
      option5: {
        tooltip: {
          // backgroundColor: "rgba(8,43,54,.8)",
          borderColor: "#082B36",
          extraCssText:
            "box-shadow:inset 0px 0px 3px 0px rgba(255,255,255,1);color:#fff;",
        },
        color: [
          "#FDD56A",
          "#9C61F6",
          "#02DBE3",
          "#18AEF0",
          "rgba(0,0,0,0)",
        ],
        tooltip: {
          show: false,
          //   trigger: "axis",
          //   // axisPointer: {
          //   //   // Use axis to trigger tooltip
          //   //   // width:20,
          //   //   // type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          //   // },
          //   // backgroundColor: "rgba(8,43,54,.8)",
          //   // borderColor: "#082B36",
          //   // extraCssText:
          //   //   "box-shadow:inset 0px 0px 3px 0px rgba(255,255,255,1);width:8.0833rem;height:5.25rem;",
          //   // textStyle: {
          //   //   color: "#fff",
          //   // },
        },
        series: [
          {
            name: "",
            roseType: "radius",
            type: "pie",
            hoverAnimation: true,
            startAngle: 180,
            radius: ["40%", "100%"],
            center: ["50%", "70%"],
            label: {
              normal: {
                // show: true,
                // position: "inner", //显示在扇形上
                formatter: function (val) {
                  var name = val.data.name;
                  var val = val.data.value;
                  var color;
                  if (name == _this.cuMap[0].name) color = "aa";
                  else if (name == _this.cuMap[1].name) color = "bb";
                  else if (name == _this.cuMap[2].name) color = "cc";
                  else if (name == _this.cuMap[3].name) color = "dd";
                  else if (name == _this.cuMap[4].name) color = "ee";
                  if (name == "o") return "";
                  return "{" + color + "|" + name + "\n" + val + "%" + "}";
                }, //显示内容
                rich: {
                  aa: {
                    height: ((screen.availWidth - 374) * 20) / 1546,
                    color: "#FDD56A",
                  },
                  bb: {
                    height: ((screen.availWidth - 374) * 20) / 1546,
                    color: "#9C61F6",
                  },
                  cc: {
                    height: ((screen.availWidth - 374) * 20) / 1546,
                    color: "#02DBE3",
                  },
                  dd: {
                    height: ((screen.availWidth - 374) * 20) / 1546,
                    color: "#18AEF0",
                  },
                  ee: {
                    height: ((screen.availWidth - 374) * 20) / 1546,
                    color: "#4DC95A",
                  },
                },
                // textStyle: {
                //   color: "white", // 改变标示文字的颜色
                //   // fontSize: ((screen.availWidth - 374) * 16) / 1546, //文字大小

                //   // fontWeight: "bold",
                // },
              },
            },
            labelLine: {
              length: ((screen.availWidth - 374) * 1) / 1546,
              length2: ((screen.availWidth - 374) * 10) / 1546,
            },
            data: [],
            // emphasis: {
            //   // shadowBlur: 10,
            //   // shadowOffsetX: 0,
            //   // shadowColor: "rgba(0, 0, 0, 0.5)",
            // },
          },
        ],
      },
      option6: {
        label: {
          show: false,
        },
        series: [
          {
            color: ["#26FAF8"],
            type: "liquidFill",
            period: 2200,
            // data: [],
            data: [0.6, 0.5],
            label: {
              show: false,
              // normal: {
              //     textStyle: {
              //         color: '#fff',
              //         insideColor: 'yellow',
              //         fontSize: ((screen.availWidth - 374) * 28) / 1546,
              //         fontWeight:700,
              //     }
              // }
            },
            radius: "95%",
            center: ["50%", "50%"],
            outline: {
              itemStyle: {
                borderColor: "transparent",
                borderWidth: ((screen.availWidth - 374) * 2) / 1546,
              },
            },
            backgroundStyle: {
              color:  {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  // !! 在此添加渐变过程色 !!
                  { offset: 0, color: "rgba(38,250,248,0)" },
                  { offset: 0.6, color: "rgba(38,250,248,0.0)" },
                  { offset: 1, color: "rgba(38,250,248,.25)" }
                ]
              }
            },
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["85%", "90%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                name: "",
                value: 0, //进度
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: '#26FAF8'
                  // {
                  //   type: "linear",
                  //   x: 0.5,
                  //   y: 0,
                  //   x2: 0,
                  //   y2: 1,
                  //   // x: 0,
                  //   // y: 0,
                  //   // x2: 1,
                  //   // y2: 2,
                  //   colorStops: [
                  //     // !! 在此添加渐变过程色 !!
                  //     { offset: 0, color: "rgba(38,250,248,0)" },
                  //     { offset: 0.5, color: "rgba(38,250,248,0.5)" },
                  //     { offset: 1, color: "rgba(38,250,248,1)" }
                  //   ]
                  // }
                },
              },
              {
                data:100,
                itemStyle:{
                  color:"transparent"
                }
              }
            ]
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["80%", "100%"], //进度线粗细
            hoverAnimation: false,
            tooltip:{
              show:false
            },
            data: [
              {
                //画剩余的刻度圆环
                name: "",
                value: 100,
                itemStyle: {
                  color: "rgba(38,250,248,.05)"
                },
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
              }
            ]
          }
        ],
      },
      option7: {
        label: {
          show: false,
        },
        series: [
          {
            color: ["#27A1FB"],
            type: "liquidFill",
            period: 2200,

            // data: [],
            amplitude: "6%",
            data: [0.6, 0.5],
            label: {
              show: false,
              // normal: {
              //     textStyle: {
              //         color: '#fff',
              //         insideColor: 'yellow',
              //         fontSize: ((screen.availWidth - 374) * 28) / 1546,
              //         fontWeight:700,
              //     }
              // }
            },
            radius: "95%",
            center: ["50%", "50%"],
            outline: {
              itemStyle: {
                borderColor: "transparent",
                borderWidth: ((screen.availWidth - 374) * 2) / 1546,
              },
            },
            backgroundStyle: {
              // color: "rgba(10,234,218,.1)",
              color:  {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  // !! 在此添加渐变过程色 !!
                  { offset: 0, color: "rgba(39,161,251,0)" },
                  { offset: 0.6, color: "rgba(39,161,251,0.0)" },
                  { offset: 1, color: "rgba(39,161,251,.25)" }
                ]
              }
            },
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            // radius: ["90%", "85%"], //进度线粗细
            radius: ["85%", "90%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                name: "",
                value: 0, //进度
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: "rgba(39,161,251,1)"
                  // {
                  //   type: "linear",
                  //   x: 0.5,
                  //   y: 0,
                  //   x2: 0.5,
                  //   y2: 1,
                  //   // x: 0,
                  //   // y: 0,
                  //   // x2: 1,
                  //   // y2: 2,
                  //   colorStops: [
                  //     // !! 在此添加渐变过程色 !!
                  //     { offset: 0, color: "rgba(39,161,251,0)" },
                  //     { offset: 0.5, color: "rgba(39,161,251,0.5)" },
                  //     { offset: 1, color: "rgba(39,161,251,1)" }
                  //   ]
                  // }
                },
              },
              {
                data:100,
                itemStyle:{
                  color:"transparent"
                }
              }
            ]
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["80%", "100%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                //画剩余的刻度圆环
                name: "",
                value: 100,
                itemStyle: {
                  // color: "rgba(39,161,251,.175)",
                  color: "rgba(39,161,251,.075)",
                  // color: [
                  //   {offset: 0,color: 'rgba(39,161,251,.175)'},
                  //   {offset: 0.5,color: 'rgba(39,161,251,.3)'},
                  //   {offset: 1,color:'rgba(39,161,251,.5)'}
                  //   ]
                },
                backgroundStyle:{},
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
              }
            ]
          }
        ],
      },
      option8: {
        label: {
          show: false,
        },
        series: [
          {
            color: ["#FBEC2B"],
            type: "liquidFill",
            period: 2200,
            // data: [],
            data: [0.6, 0.5],
            label: {
              show: false,
              // normal: {
              //     textStyle: {
              //         color: '#fff',
              //         insideColor: 'yellow',
              //         fontSize: ((screen.availWidth - 374) * 28) / 1546,
              //         fontWeight:700,
              //     }
              // }
            },
            radius: "95%",
            center: ["50%", "50%"],
            outline: {
              itemStyle: {
                // borderColor: "#FBEC2B",
                borderColor: "transparent",
                borderWidth: ((screen.availWidth - 374) * 2) / 1546,
              },
            },
            backgroundStyle: {
              // shadowColor:"#fff",
              // shadowBlur: 4,
              // color: "rgba(10,234,218,.1)",
              color:  {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  // !! 在此添加渐变过程色 !!
                  { offset: 0, color: "rgba(251,236,43,0)" },
                  { offset: 0.6, color: "rgba(251,236,43,0.0)" },
                  { offset: 1, color: "rgba(251,236,43,.25)" }
                ]
              }
            },
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["85%", "90%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                name: "",
                value: 0, //进度
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: "rgba(251,236,43,1)"
                },
              },
              {
                data:100,
                itemStyle:{
                  color:"transparent"
                }
              }
            ]
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["80%", "100%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                //画剩余的刻度圆环
                name: "",
                value: 100,
                itemStyle: {
                  color: "rgba(251,236,43,.075)"
                },
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
              }
            ]
          }
        ],
      },
      option9: {
        label: {
          show: false,
        },
        series: [
          {
            color: ["#8C57DC"],
            type: "liquidFill",
            period: 2200,
            // data: [],
            data: [0.6, 0.5],
            label: {
              show: false,
              // normal: {
              //     textStyle: {
              //         color: '#fff',
              //         insideColor: 'yellow',
              //         fontSize: ((screen.availWidth - 374) * 28) / 1546,
              //         fontWeight:700,
              //     }
              // }
            },
            radius: "95%",
            center: ["50%", "50%"],
            outline: {
              itemStyle: {
                // borderColor: "#FBEC2B",
                borderColor: "transparent",
                borderWidth: ((screen.availWidth - 374) * 2) / 1546,
              },
            },
            backgroundStyle: {
              // shadowColor:"#fff",
              // shadowBlur: 4,
              // color: "rgba(10,234,218,.1)",
              color:  {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  // !! 在此添加渐变过程色 !!
                  { offset: 0, color: "rgba(140,87,220,0)" },
                  { offset: 0.6, color: "rgba(140,87,220,0.0)" },
                  { offset: 1, color: "rgba(140,87,220,.25)" }
                ]
              }
            },
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["85%", "90%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                name: "",
                value: 0, //进度
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: "rgba(140,87,220,1)"
                },
              },
              {
                data:100,
                itemStyle:{
                  color:"transparent"
                }
              }
            ]
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["80%", "100%"], //进度线粗细
            hoverAnimation: false,
            data: [
              {
                //画剩余的刻度圆环
                name: "",
                value: 100,
                itemStyle: {
                  color: "rgba(251,236,43,.075)"
                },
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
              }
            ]
          }
        ],
      },
      policyLearning: [], // 碳吸收贡献率
      researchResult:[], // 研究出成果
      iceMap: [], // 各行业碳排放排行
      ceMap: [], // 碳排贡献率
      ceotList: [], // 历年碳排趋势分析
      aceMap: {
        arr: "0,000,000",
        biogasManure: 0,
        hydropower: 0,
        plantedForest: 0,
      }, //  年度碳排数据
      cerMap: {
        teaCoffee: 0, // teaCoffee
        plantedForest: 0, // plantedForest
        hydropower: 0, // 水电
        biogasManure: 0, // 沼气粪肥量
        sum: 0, // 汇总
      }, // 历年碳排趋势分析
      cuMap: [], // 碳吸收贡献率
      mediaCoverage: [
        [
          { type: "mp4", url: "" },
          { type: "mp4", url: "" },
        ],
      ], // 视频
      year:2022, // 年份
    };
  },
  methods: {
    init() {
      const that = this;
      const bodyWidth = screen.availWidth - 374;
      const screenWidth = screen.availWidth;
      that.setFont(bodyWidth);
      that.getYear()
      that.initMap();
      that.getData();
      that.$set(that, "cuMap", that.list);
      that.$set(that.option5.series[0], "data", that.list);
      that.option5.series[0].data = that.list;
      // that.$refs.echarts1.myEcharts(that.option1);
      // // // that.$refs.echarts2.myEcharts(that.option2);
      // that.$refs.echarts3.myEcharts(that.option3);
      // that.$refs.echarts5.myEcharts(that.option5);
      // that.$refs.echarts6.myEcharts(that.option6);
      // that.$refs.echarts7.myEcharts(that.option7);
      // that.$refs.echarts8.myEcharts(that.option8);
      // that.$refs.echarts9.myEcharts(that.option9);
      document.addEventListener("fullscreenchange", (e) => {
        if (document.fullscreenElement) {
          that.$set(
            that.option1.series[0].labelLine.normal,
            "length",
            (screenWidth * 10) / 1546
          );
          that.$set(
            that.option1.series[0].label,
            "fontSize",
            (screenWidth * 16) / 1546
          );
          that.$set(
            that.option1.series[0].label,
            "height",
            (screenWidth * 40) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.name,
            "height",
            (screenWidth * 20) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.aa,
            "fontSize",
            (screenWidth * 18) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.bb,
            "fontSize",
            (screenWidth * 18) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.cc,
            "fontSize",
            (screenWidth * 18) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.dd,
            "fontSize",
            (screenWidth * 18) / 1546
          );

          that.$set(
            that.option3.tooltip,
            "itemWidth",
            (screenWidth * 6) / 1546
          );
          that.$set(
            that.option3.tooltip,
            "itemHeight",
            (screenWidth * 6) / 1546
          );
          that.$set(that.option3.legend, "top", (screenWidth * 6) / 1546);
          that.$set(that.option3.legend, "itemWidth", (screenWidth * 6) / 1546);
          that.$set(
            that.option3.legend,
            "itemHeight",
            (screenWidth * 6) / 1546
          );
          that.$set(
            that.option3.legend.textStyle,
            "fontSize",
            (screenWidth * 12) / 1546
          );

          that.$set(
            that.option5.series[0].label.normal.rich.aa,
            "height",
            (screenWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.bb,
            "height",
            (screenWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.cc,
            "height",
            (screenWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.dd,
            "height",
            (screenWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.ee,
            "height",
            (screenWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].labelLine,
            "length",
            (screenWidth * 1) / 1546
          );
          that.$set(
            that.option5.series[0].labelLine,
            "length2",
            (screenWidth * 10) / 1546
          );

          that.$set(
            that.option6.series[0].outline.itemStyle,
            "borderWidth",
            (screenWidth * 2) / 1546
          );

          that.$set(
            that.option7.series[0].outline.itemStyle,
            "borderWidth",
            (screenWidth * 2) / 1546
          );

          that.$set(
            that.option8.series[0].outline.itemStyle,
            "borderWidth",
            (screenWidth * 2) / 1546
          );

          that.$set(
            that.option9.series[0].outline.itemStyle,
            "borderWidth",
            (screenWidth * 2) / 1546
          );

          that.setFont(screenWidth);
          // that.$set(that.option1.legend,"itemWidth",(screenWidth * 6) / 1546);
        } else {
          that.$set(
            that.option1.series[0].labelLine.normal,
            "length",
            (bodyWidth * 10) / 1546
          );
          that.$set(
            that.option1.series[0].label,
            "fontSize",
            (bodyWidth * 16) / 1546
          );
          that.$set(
            that.option1.series[0].label,
            "height",
            (bodyWidth * 40) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.name,
            "height",
            (bodyWidth * 20) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.aa,
            "fontSize",
            (bodyWidth * 18) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.bb,
            "fontSize",
            (bodyWidth * 18) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.cc,
            "fontSize",
            (bodyWidth * 18) / 1546
          );
          that.$set(
            that.option1.series[0].label.rich.dd,
            "fontSize",
            (bodyWidth * 18) / 1546
          );

          that.$set(that.option3.tooltip, "itemWidth", (bodyWidth * 6) / 1546);
          that.$set(that.option3.tooltip, "itemHeight", (bodyWidth * 6) / 1546);
          that.$set(that.option3.legend, "top", (bodyWidth * 6) / 1546);
          that.$set(that.option3.legend, "itemWidth", (bodyWidth * 6) / 1546);
          that.$set(that.option3.legend, "itemHeight", (bodyWidth * 6) / 1546);
          that.$set(
            that.option3.legend.textStyle,
            "fontSize",
            (bodyWidth * 12) / 1546
          );

          that.$set(
            that.option5.series[0].label.normal.rich.aa,
            "height",
            (bodyWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.bb,
            "height",
            (bodyWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.cc,
            "height",
            (bodyWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.dd,
            "height",
            (bodyWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].label.normal.rich.ee,
            "height",
            (bodyWidth * 20) / 1546
          );
          that.$set(
            that.option5.series[0].labelLine,
            "length",
            (bodyWidth * 1) / 1546
          );
          that.$set(
            that.option5.series[0].labelLine,
            "length2",
            (bodyWidth * 10) / 1546
          );

          that.$set(
            that.option6.series[0].outline.itemStyle,
            "borderWidth",
            (bodyWidth * 2) / 1546
          );

          that.$set(
            that.option7.series[0].outline.itemStyle,
            "borderWidth",
            (bodyWidth * 2) / 1546
          );

          that.$set(
            that.option8.series[0].outline.itemStyle,
            "borderWidth",
            (bodyWidth * 2) / 1546
          );

          that.$set(
            that.option9.series[0].outline.itemStyle,
            "borderWidth",
            (bodyWidth * 2) / 1546
          );

          that.setFont(bodyWidth);
        }
        that.$refs.echarts1.myChart.resize();
        // that.$refs.echarts2.myChart.resize();
        that.$refs.echarts3.myChart.resize();
        that.$refs.echarts5.myChart.resize();
        that.$refs.echarts6.myChart.resize();
        that.$refs.echarts7.myChart.resize();
        that.$refs.echarts8.myChart.resize();
        that.$refs.echarts9.myChart.resize();
        that.myChart.resize();
        that.myChart1.resize();
      });
    },
    // 获取当前年份-1
    getYear(){
      const date = new Date();
      let month = date.getMonth() + 1
      let num = month < 6 ? 2 : 1
      const year = date.getFullYear() - num
      this.year = year
    },
    //适配尺寸
    setFont(width) {
      // 获取设备屏幕的宽度
      let html = document.documentElement;
      // 计算html的fontSize值
      var fontSize = width / 80 + "px";
      // 设置html元素的font-size
      html.style.fontSize = fontSize;
    },
    // 点击全屏
    handleFullScreen() {
      let element = document.getElementById("Echart_cont");
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
      }
    },
    // 重新加载Echarts
    echartResize() {
      const that = this;

      that.setFont(screenWidth);
    },
    // 初始化地图
    initMap() {
      this.$echarts.registerMap("ninger", ninger);
      this.myChart = this.$echarts.init(document.getElementById("Map"));
      this.option4.toolbox.feature.myFull.icon='image://'+require('@/assets/img/bigger.svg')
      this.initMapData()
      this.myChart.setOption(this.option4);
    },
    showDialog(){
      this.dialogVisible=true
      this.$nextTick(()=>{
        this.option10.toolbox.feature.myFull.icon='image://'+require('@/assets/img/close.svg')
        this.myChart1 = this.$echarts.init(document.getElementById("Map1"));
        this.myChart1.setOption(this.option10);
      })
    },
    closeDialog(){
      this.dialogVisible=false
      this.mapShow=true
    },
    initMapData(){
      this.mapData=[
          { name: '黎明乡', data1:380.99,data2:484.91,data3:233.07,data4:64.2},
          { name: '勐先镇', data1:316.81,data2:346.34,data3:169.58,data4:46.83 },
          { name: '普义乡', data1:249.45,data2:301.44,data3:145.86,data4:55.63 },
          { name: '同心镇', data1:241.83,data2:255.61,data3:124.87,data4:55.78 },
          { name: '德化镇', data1:274.43,data2:244.5,data3:122.72,data4:46.27 },
          { name: '宁洱镇', data1:429.75,data2:410.98,data3:204.1,data4:55.43 },
          { name: '磨黑镇', data1:354.75,data2:355.2,data3:175.46,data4:48.16 },
          { name: '德安乡', data1:324.42,data2:368.41,data3:179.49,data4:62.47 },
          { name: '梅子镇', data1:220.07,data2:231.42,data3:113.08,data4:51.06 }]
      this.option4.series[0].data=this.mapData.map((item)=>({name:item.name,value:item.data4}))
      this.option10.series[0].data=this.mapData.map((item)=>({name:item.name,value:item.data4}))
    },
    // 处理数据各行业碳排放排行数据
    changeIceMap(data) {
      let arr = [];
      data.forEach((e) => {
        for (let key in e) {
          let obj = {
            val: e[key],
            name: "",
          };
          if (key == "agriculturalProduction") obj.name = "农业生产";
          else if (key == "residentPhotograph") obj.name = "非居民照明";
          else if (key == "transportationIndustry") obj.name = "交通运输业";
          else if (key == "agriculturalDrainage") obj.name = "农业排灌";
          else if (key == "aquaculture") obj.name = "养殖业";
          else if (key == "generalIndustrial") obj.name = "非普工业";
          else if (key == "business") obj.name = "商业";
          else if (key == "greatIndustry") obj.name = "大工业";
          else if (key == "residentsLiving") obj.name = "居民生活";
          arr.push(obj);
        }
      });
      this.iceMap = arr;
      this.$refs.progressBar.init();
    },
    // 处理碳排贡献率数据
    changeCeMap(data) {
      let arr = [];
      for (let key in data) {
        let obj = {
          proportion: data[key],
          value: data[key],
        };
        if (key == "agriculture") obj.name = "农业排放量";
        else if (key == "industrial") obj.name = "工业排放量";
        else if (key == "otherIndustries") obj.name = "其他行业量";
        else if (key == "transportation") obj.name = "交通运输排放量";
        arr.push(obj);
      }
      this.$set(this.option1.series[0], "data", arr);
    },
    // 处理碳吸收贡献率
    changeCuMao(data) {
      let arr = [];
      delete data.teaCoffee
      for (let key in data) {
        let obj = {
          proportion: data[key],
          value: data[key],
        };
        if (key == "teaCoffee") obj.name = "茶叶咖啡种植";
        else if (key == "biogasManure") obj.name = "沼气粪肥";
        else if (key == "plantedForest") obj.name = "人工林";
        else if (key == "naturalForest") obj.name = "天然林";
        else if (key == "hydropower") obj.name = "水电";
        arr.push(obj);
      }
      let sum = 0;
      arr.map((item, index) => {
        sum += parseInt(item.value);
      });
      if (sum == 0) {
        for (let key in data) {
          arr.push({ name: "o", value: 0, proportion: 0 });
        }
      } else arr.push({ name: "o", value: sum, proportion: sum });

      this.cuMap = arr;
      console.log(arr,123456)
      this.$set(this.option5.series[0], "data", arr);
    },
    // 处理历年碳排趋势分析
    changeCeoList(data) {
      let arr1 = [0, 0, 0, 0, 0];
      let arr2 = [0, 0, 0, 0, 0];
      let arr3 = [0, 0, 0, 0, 0];
      let arr4 = [0, 0, 0, 0, 0];
      // let year = ["2017", "2018", "2019", "2020", "2021"];
      let year = [];
      for(let i=0;i<5;i++){
        let y = this.year - i
        year.unshift(y.toString())
      }
      this.$set(this.option3.xAxis[0], "data", year);
      data.forEach((item) => {
        let len = year.indexOf(item.year);
        if(len != -1){
          arr1.splice(len, 1, item.industrialProduction);
          arr2.splice(len, 1, item.agriculturalProduction);
          arr3.splice(len, 1, item.transportation);
          arr4.splice(len, 1, item.otherIndustries);
        }
      });
      this.$set(this.option3.series[0], "data", arr1);
      this.$set(this.option3.series[1], "data", arr2);
      this.$set(this.option3.series[2], "data", arr3);
      this.$set(this.option3.series[3], "data", arr4);
    },
    // 处理工作推进成果(视频、图片)
    changeMediaCoverage(data) {
      let arr1 = [];
      let arr2 = [];
      let newArr = [];
      let typeArr = ['mp4','mov','jpg','png','jpeg','svg','webp','jfif']
      data.forEach((e) => {
        if (e.accessory)
          JSON.parse(e.accessory).forEach((el) =>{
            el.detailId = e.id
             newArr.push(el)
          });
      });
      newArr.forEach((e, i) => {
        if(typeArr.indexOf(e.type)!= -1)
          arr2.push(e);
        if (i % 2 == 1) {
          arr1.push(arr2);
          arr2 = [];
        }
        if (i == newArr.length - 1 && arr2.length) {
          arr2.push({
            type: "png",
            url: require("@/assets/img/img.png"),
          });
          arr1.push(arr2);
          arr2 = [];
        }
      });
      if (arr1.length == 2) arr1 = [...arr1, ...arr1];
      this.mediaCoverage = arr1;
      // this.mediaCoverage = arr2;
    },
    // 每三位加一个,
    changeAceMapArr(num, bol = false) {
      num = parseInt(num).toString();
      if (!bol) {
        if (num.length < 7) {
          let len = 7 - num.length;
          for (let i = 0; i < len; i++) {
            num = "0" + num;
          }
        }
      }
      return num.replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    },
    // 获取大屏数据
    async getData() {
      const res = await getBigScreenData();
      if (res.data.code == 200) {
        const that = this;
        const { data } = res.data;
        that.policyLearning = data.policyLearning;
        that.researchResult = data.researchResult;
        that.changeIceMap(data.iceMap);
        that.changeCeMap(data.ceMap);
        this.$set(this.option5.series[0], "data", that.list);
        that.changeCuMao(data.cuMap);
        that.changeCeoList(data.ceotList);
        that.changeMediaCoverage(data.mediaCoverage);
        that.ceotList = data.ceotList;
        data.aceMap.arr = that.changeAceMapArr(data.aceMap.biogasManure);
        data.aceMap.biogasManure = data.aceMap.biogasManure|0
        data.aceMap.plantedForest = that.changeAceMapArr(
          data.aceMap.plantedForest,
          true
        );
        data.aceMap.hydropower = that.changeAceMapArr(
          data.aceMap.hydropower,
          true
        );
        that.aceMap = data.aceMap;
        that.cerMap = data.cerMap;
        that.$set(that.option6.series[0], "data", [
          data.cerMap.biogasManure / 100,
        ]);
        that.$set(that.option6.series[1].data[0],"value",data.cerMap.biogasManure);
        that.$set(that.option6.series[1].data[1],"value",100 - data.cerMap.biogasManure);
        that.$set(that.option7.series[0], "data", [
          data.cerMap.plantedForest / 100,
        ]);
        that.$set(that.option7.series[1].data[0],"value",data.cerMap.plantedForest);
        that.$set(that.option7.series[1].data[1],"value",100 - data.cerMap.plantedForest);
        that.$set(that.option8.series[0], "data", [
          data.cerMap.hydropower / 100,
        ]);
        that.$set(that.option8.series[1].data[0],"value",data.cerMap.hydropower);
        that.$set(that.option8.series[1].data[1],"value",100 - data.cerMap.hydropower);

        that.$set(that.option9.series[0],'data',[(data.cerMap.teaCoffee/100)])
        that.$set(that.option9.series[1].data[0],"value",data.cerMap.teaCoffee);
        that.$set(that.option9.series[1].data[1],"value",100 - data.cerMap.teaCoffee);

        that.$refs.echarts1.myEcharts(that.option1);
        that.$refs.echarts3.myEcharts(that.option3);
        that.$refs.echarts5.myEcharts(that.option5);
        that.$refs.echarts6.myEcharts(that.option6);
        that.$refs.echarts7.myEcharts(that.option7);
        that.$refs.echarts8.myEcharts(that.option8);
        that.$refs.echarts9.myEcharts(that.option9);
      }
    },
    // 跳转至政策信息详情
    toPathDetail(id){
      if(id){
        window.localStorage.setItem('policyInformation_detail_id',id)
        this.$router.push('/policyInformation')
      }
    }
  },
  mounted() {
    this.init();
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    _this = this;
  },
  components: {
    Breadcrumbs,
    Echarts,
    ScrollList,
    ProgressBar,
    Swiper,
    Dialog
  },
};
</script>
<style scoped>
@font-face {
  font-family: "PangMenZhengDao";
  src: url("../../../assets/css/PangMenZhengDaoBiaoTiTi-1.ttf");
}
.carbonSinkResources {
  position: relative;
  overflow: hidden;
}
.carbonSinkResources .full {
  height: 50px;
  top: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
}
.carbonSinkResources .full > img {
  display: block;
  width: 40px;
  height: 40px;
}
/* .echart_content {
  position: relative;
  width: 100%;
  height: calc(100vh - 50px - 60px);
  background: #ddd;
} */

#fullscreen {
  position: relative;
  background-image: url("../../../assets/img/bg_img.png");
  background-repeat: no-repeat;
  background-size: 80rem 45rem;
  height: 45.0194rem;
}
.dialog{
  width: 79.65rem;
  height: 45.0194rem;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
  /*background-image: url("../../../assets/img/bg_img.png");*/
  /*background-repeat: no-repeat;*/
  /*background-size: 80rem 45rem;*/
}
.content {
  position: relative;
}
.content_left {
  /* position: absolute;
    left: 1.25rem;
    width: 21.25rem; */
}
.content_left_item1 {
  position: absolute;
  width: 21.25rem;
  height: 10.4167rem;
  left: 1.25rem;
  top: 2.5rem;
}
.content_left_item2 {
  position: absolute;
  width: 21.25rem;
  height: 20.8333rem;
  left: 1.25rem;
  top: 12.5rem;
}
.content_left_item3 {
  position: absolute;
  width: 21.25rem;
  height: 10.4167rem;
  left: 1.25rem;
  top: 33.9583rem;
}
.content_center_tit {
  position: absolute;
  top: 0.4167rem;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  white-space: nowrap;
  /* font-family: PangMenZhengDao; */
  /* transform: translate3d(-50%,0,0); */
  font-size: 2rem;
  color: #ffffff;
  letter-spacing: 0.1858rem;
  font-weight: 700;
}
.content_center_total {
  width: auto;
}
.content_center_total .total_tit {
  position: absolute;
  top: 4.5833rem;
  left: 27.2917rem;
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #ffffff;
  text-align: left;
  white-space: nowrap;
  font-weight: 400;
}
.content_center_total .total_unit {
  position: absolute;
  right: -1.25rem;
  bottom: 0.625rem;
  color: #fff;
  font-size: 1rem;
  vertical-align: sub;
}
.content_center_total .total_cont {
  position: absolute;
  top: 6.0417rem;
  left: 27.2917rem;
  display: flex;
  align-content: center;
  justify-content: center;
}
.total_cont_item {
  margin: 0.2083rem.2083rem 0 0;
  width: 2.25rem;
  height: 3.25rem;
  text-align: center;
  line-height: 3.25rem;
  font-family: PingFangSC-Regular;
  font-size: 2.5rem;
  color: #ffffff;
  letter-spacing: 0;
  text-shadow: 0 0 0.375rem #0c6f52;
  font-weight: 400;
  background-image: url("../../../assets/img/num_border.png");
  background-repeat: no-repeat;
  background-size: 2.25rem 3.25rem;
}
.total_cont .total_cont_item:nth-last-child(2) {
  margin-right: 0.4167rem;
}
.cont_title {
  /* width: 15.5417rem; */
  min-width: 17rem;
  height: 2.0833rem;
  box-sizing: border-box;
  background-image: url("../../../assets/img/title.png");
  background-repeat: no-repeat;
  background-size: 15.5417rem 2.0833rem;
  font-family: "PangMenZhengDao";
  font-size: 1.1667rem;
  color: #ffffff;
  letter-spacing: 0.125rem;
  text-shadow: 0 0.0833rem 0.2083rem #03b194;
  font-weight: 400;
}
.conten_item_l {
  top: 10rem;
  left: 50%;
  transform: translate3d(-50%,0,0);
  position: absolute;
  display: flex;
  flex-direction: column;
}
.conten_item_r {
  top: 10rem;
  left: 43.0833rem;
  position: absolute;
  display: flex;
  flex-direction: column;
}
.conten_item_t {
  white-space: nowrap;
  text-align: left;
  font-size: 0.75rem;
  color: #ffffff;
}
.conten_item_c {
  margin-top: 0.25rem;
  position: relative;
  font-family: PangMenZhengDao;
  font-size: 1.3333rem;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  text-shadow: 0 0.2917rem 0.1667rem rgba(2, 2, 28, 0.8);
  font-weight: 400;
  width: 14.4167rem;
}
.conten_item_l .conten_item_c {
  background-image: linear-gradient(
    0deg,
    rgba(8, 107, 103, 0) 0%,
    rgba(12, 181, 189, 0.59) 100%
  );
}
.conten_item_r .conten_item_c {
  background-image: linear-gradient(
    0deg,
    rgba(8, 52, 107, 0) 0%,
    rgba(12, 87, 189, 0.59) 100%
  );
}
.conten_item_c > span {
  font-size: 0.6667rem;
}
.conten_item_c::after {
  content: "";
  display: block;
  position: absolute;
  top: -0.1667rem;
  left: 0;
  right: 0;
  height: 0.0833rem;
}
.conten_item_l .conten_item_c::after {
  background-image: linear-gradient(0deg, #00ffc7 10%, #00ffc1 100%);
}
.conten_item_r .conten_item_c::after {
  background-image: linear-gradient(0deg, #00ffc7 10%, #00b4ff 100%);
}
.cont_title > div {
  margin-left: 2.0833rem;
  height: 2.0833rem;
  vertical-align: bottom;
  line-height: 2;
}
#Map {
  width: 37rem;
  height: 20.3333rem;
  position: absolute;
  top: 13rem;
  left: 21.6667rem;
}
#Map1 {
  top:1rem;
  width: 78rem;
  height: 45.0194rem;
  position: absolute;
}
.map_table{
  position: absolute;
  top: 13rem;
  color: #fff;
  font-size: 0.5rem;
  text-align: center;
  background: rgb(19 36 57 / 77%);
  border-spacing: 0;
  font-weight: lighter;
  border: 0.01rem solid rgba(61, 182, 216, 0.44);
  min-width: 11rem;
  right: 20.7rem;
}
.map_table div{
  line-height: 0.5rem;
  font-size: 0.4rem;

}
.map_table td{
  padding:0 0.2rem;
}
.map_cont {
  padding: 0 0.5rem;
  position: absolute;
  top: 24.5rem;
  left: 45.6667rem;
  width: 9.0833rem;
  height: 5.6583rem;
  color: #fff;
  box-sizing: border-box;
  background-image: url("../../../assets/img/cont_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.map_cont .map_cont_title {
  padding: 0.5rem 0 0;
  text-align: center;
  font-size: 1.05rem;
}
.map_cont .map_cont_title span{
  font-family: PangMenZhengDao;
}
.map_cont .map_cont_c {
  margin-top: 0.5rem;
  display: flex;
  justify-content: center;
}
.map_cont .map_cont_c span {
  font-size: 0.66rem;
}
.map_cont .map_cont_c em {
  font-size: 1.3333rem;
  white-space: nowrap;
  font-family: PangMenZhengDao;
  font-style: normal;
}
.content_b {
  /* width: 32.6667rem; */
  width: 33.5rem;
  position: absolute;
  top: 32.9167rem;
  left: 23.3rem;
}
.content_b_video {
  height: 9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content_b > div video {
  width: 16rem;
  height: 9rem;
}
.content_b > div img {
  display: block;
  width: 16rem;
  height: 9rem;
}
/*  */
.content_right_item1 {
  position: absolute;
  top: 2.5rem;
  left: 60.6667rem;
}
.content_right_item2 {
  position: absolute;
  /* top: 15.9167rem; */
  top: 14.167rem;
  left: 60.6667rem;
}
.content_item2_cont {
  margin: 0.625rem 0 0.4167rem 0;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.content_item2_cont > span {
  margin-right: 0.25rem;
  font-family: PangMenZhengDao;
  font-size: 0.8333rem;
}
.content_item2_cont > div {
  width: 10rem;
  height: 1.9167rem;
  background-image: url("../../../assets/img/result_bg.png");
  background-repeat: no-repeat;
  font-family: AdiHaus-Bold;
  font-size: 1.25rem;
  background-size: 10rem 1.9167rem;
  line-height: 1.9167rem;
  text-align: center;
}
.content_right_item3{
  min-width: 15rem;
  position: absolute;
  /* top: 32.9167rem; */
  top: 29.567rem;
  left: 60.6667rem;
}
.content_right_item4{
  min-width: 15rem;
  position: absolute;
  /* top: 32.9167rem; */
  top: 37.2rem;
  left: 60.6667rem;
}

::v-deep .content_right_item3 .list > li > span ,::v-deep .content_right_item4 .list > li > span {
  font-size: 0.72rem;
}
::v-deep .content_right_item3 .list > li > span:nth-child(1),::v-deep .content_right_item4 .list > li > span:nth-child(1) {
  margin-right: .4167rem;
  width: 4rem;
}
::v-deep .content_right_item3 .list > li > span:nth-child(2) {
  width: 11.6667rem;
}
::v-deep .content_right_item3 .list > li:nth-child(2n),::v-deep .content_right_item4 .list > li:nth-child(2n)  {
  background: #10212b;
}
::v-deep .content_right_item4 .list > li > span:nth-child(2) {
  margin-right: .4167rem;
  width: 5.6667rem;
}
::v-deep .content_right_item4 .list > li > span:nth-child(3){
  width: 5.6667rem;
}
.content_right_item3 .scroll ,.content_right_item4 .scroll {
  margin-top: 0.8333rem;
  /* margin-left: 2.5833rem; */
  /* width: 14.625rem; */
  height: 4.3333rem;
}
.Echarts_cont {
  position: absolute;
  left: 4.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.Echarts_cont > em {
  font-style: normal;
  font-size: 1rem;
  font-family: PangMenZhengDao;
}
.Echarts_right_2_1 .Echarts_cont > em {
  color: #27a1fb;
}
.Echarts_right_2_2 .Echarts_cont > em {
  color: #8C57DC;
}
.Echarts_right_2_3 .Echarts_cont > em {
  color: #fbec2b;
}
.Echarts_right_2_4 .Echarts_cont > em {
  /* color: #8c80ff; */
  color: #26faf8;
}
.Echarts_cont > span {
  font-family: MicrosoftYaHei;
  font-size: 0.75rem;
  white-space: nowrap;
}
.Echarts_left_1 {
  width: 100%;
  height: 7.5rem;
}
.Echarts_left_2 {
  width: 100%;
  height: 18.75rem;
}
.Echarts_left_3 {
  width: 100%;
  height: 8.3333rem;
}
.Echarts_right_1 {
  width: 100%;
  /* height: 10.4167rem; */
  height: 9.4167rem;
}
.Echarts_right_2_1,
.Echarts_right_2_2,
.Echarts_right_2_3,
.Echarts_right_2_4 {
  position: absolute;
  width: 4.1667rem;

  height: 4.1667rem;
  display: flex;
  align-items: center;
}
.Echarts_right_2_1 {
  top: 5.75rem;
  left: 0;
}
.Echarts_right_2_2 {
  top: 5.75rem;
  /* left: 4.57rem; */
  left: 9.1667rem;
}
.Echarts_right_2_3 {
  flex-shrink: 0;
  top: 10.75rem;
  left: 0;
}
.Echarts_right_2_4 {
  top: 10.75rem;
  left: 9.1667rem;
}
/* 进度条 */
video::-webkit-media-controls-timeline {
  display: none;
}
/* 观看的当前时间 */
video::-webkit-media-controls-current-time-display {
  display: none;
}
/* 剩余时间 */
video::-webkit-media-controls-time-remaining-display {
  display: none;
}
/* 音量按钮 */
video::-webkit-media-controls-mute-button {
  display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}
/* 音量的控制条 */
video::-webkit-media-controls-volume-slider {
  display: none;
}
/* 所有控件 */
video::-webkit-media-controls-enclosure {
  /* display: none; */
}
</style>
